import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const LOGIN_PATHNAME = '/login';

export const LoginLoadable = loadable(async () => import('./login.view'), {
  fallback: <FullPageLoading />,
});
